import React from 'react';

export const konrad = (
  <>
    <p>
      Konrad has 6 years of strong background in Embedded &amp; Networking
      programming, as well as experience leading multiple teams for UK and US
      customers, which has laid the foundations for him to become a natural
      Technology leader.
    </p>
    <p>
      A man obsessed with continuous improvements, Konrad is never satisfied
      with his results.
    </p>
    <p>
      <strong>Will help you with:</strong>
      <br />
      answering the most sophisticated questions from technology to business.
      Konrad is often involved in projects as an advisor and/or interim CTO.
    </p>
  </>
);

export const bartosz = (
  <>
    <p>
      Experienced mobile and web applications developer who continuously
      experiments with cutting edge technologies to find improved and faster
      solutions to given problems.
    </p>
    <p>
      Bartosz is someone who believes it is the &rdquo;little things that make
      big things happen&rdquo;, pushing him to pay utmost attention to detail
      when creating polished, pixel perfect, smooth and responsive applications.
    </p>
    <p>
      <strong>Will help you with:</strong>
      <br />
      getting the best in class mobile applications on the market.
    </p>
  </>
);

export const marcin = (
  <>
    <p>
      An entrepreneur who knows how to listen and how to ask questions to
      understand customers’ needs.
    </p>
    <p>
      Marcin is a founder of three tech startups, which were responsible for a
      scope from customer discovery and validation, prototyping, MVP testing and
      product development phases. Knowledgeable at supply chain, logistics,
      industrial, e-commerce as well as SaaS (software as a service) businesses.
    </p>
    <p>
      <strong>Will help you with:</strong>
      <br />
      getting you the exact support you need on your project.
    </p>
  </>
);
